
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cyber",
      function () {
        return require("private-next-pages/cyber.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cyber"])
      });
    }
  